import { Drawer } from 'antd';
import styled from 'styled-components';

export default styled(Drawer)`
	// Add your styles here
`;
